<script>
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    horas: {
      type: Boolean,
      default: false
    },
    retroativo: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DatePick
  },
  data: () => ({
    config: {
      anteriorMes: 'Mês anterior',
      proximoMes: 'Prox. mês',
      selecionaHora: 'Selecione a hora',
      formato: 'DD/MM/YYYY HH:mm',
      diasSemana: [
        'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'
      ],
      meses: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ],
      atributosImput: {
        readonly: false
      }
    }
  }),
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('model', newValue)
      }
    }
  },
  methods: {
    dataInicial (date) {
      let currentDate = new Date(0)
      if (!this.retroativo) {
        currentDate = new Date()
      }
      currentDate.setDate(currentDate.getDate() - 1)
      return date < currentDate
    }
  },
  mounted () {
    if (!this.horas) {
      this.config.formato = 'DD/MM/YYYY'
    }
  }
}
</script>

<template>
  <date-pick
    :nextMonthCaption="config.proximoMes"
    :prevMonthCaption="config.anteriorMes"
    :months="config.meses"
    :weekdays="config.diasSemana"
    :setTimeCaption="config.selecionaHora"
    :pickTime="horas"
    :format="config.formato"
    :inputAttributes="config.atributosImput"
    :isDateDisabled="dataInicial"
    v-model="model">
  </date-pick>
</template>

<style>
.vdpComponent.vdpWithInput>input {
  padding-right: 0;
  background-color: #fff;
}
button.vdpClearInput:before {
  color: rgba(62, 81, 91, 1);
  border: 1px solid rgba(62, 81, 91, .7);
}
.vdpFloating, .vdpFloating button, .vdpHeadCellContent, .vdpTimeCaption, .vdpTimeUnit span {
  color: #3e515b;
}
.vdpHeader, .vdpTimeControls {
  background: #f0f2f7;
}
.vdpHeadCell {
  width: 40px;
}
.vdpCell.today {
  color: rgba(0, 0, 0, .8);
  background: #f0f2f7;
}
.vdpCell.selectable:hover .vdpCellContent{
  background: rgba(54, 169, 225, .5);
  color: rgba(0, 0, 0, .5)
}
.vdpCell.selected .vdpCellContent {
  background: rgba(54, 169, 225, 1);
}
.vdpTimeControls {
  font-size: 12px;
}
/* oculta calendario e dá foco na hora qndo a data ja esta selecionada */
/* .selected .vdpHeader, .selected .vdpTable {
  display: none
}
.selected .vdpTimeControls {
  margin: 0px;
} */
.vdpTimeCaption {
  font-size: 14px;
}
.vdpTimeUnit {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// date-picker.vue?584b06c4